<template>
</template>

<script>
    import DingtalkService from '@/api/dingtalk/DingtalkService.js'
    import Vue from "vue";

    export default {
        data() {
            return {}
        },
        mounted() {
            this.dingtalkLogin()
        },
        methods: {
            dingtalkLogin() {
              Vue.cookie.delete('token')
              // Vue.cookie.delete('date');
              Vue.cookie.delete('name');
              Vue.cookie.delete('userId');
                dd.ready(() => {
                    // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
                    let corpId = this.getQueryVariable('corpId')
                    let businessId = this.getQueryVariable('businessId')
                    let procInsId = this.getQueryVariable('procInsId')
                    let taskId = this.getQueryVariable('taskId')
                    let taskDefKey = this.getQueryVariable('taskDefKey')
                    let procDefId = this.getQueryVariable('procDefId')
                    let service = "/" + this.getQueryVariable('service')//当前业务路径 /refund
                    dd.runtime.permission.requestAuthCode({
                        corpId: corpId,
                        onSuccess: (result) => {
                            new DingtalkService().dingtalkLogin(result.code, corpId).then(({data}) => {
                                Vue.cookie.set('token', data.token);
								// Vue.cookie.set('date', data.date);
								Vue.cookie.set('name', data.name);
                                this.$router.push({
                                    path: service,
                                    query: {
                                        id: businessId,
                                        procInsId: procInsId,
                                        taskId: taskId,
                                        taskDefKey: taskDefKey,
                                        procDefId: procDefId
                                    }
                                })
                            })
                            //  $.ajax({
                            // url: 'http://172.16.1.68:8082/sys/dingtalkLogin?code=' + result.code + '&corpId=' + corpId,
                            // type: 'post',
                            // success(res) {
                            // 	$.cookie('token', res.token)
                            // 	this.$router.push({
                            // 		path: service,
                            // 		query: {
                            // 			id: businessId,
                            // 			procInsId: procInsId,
                            // 			taskId: taskId,
                            // 			taskDefKey: taskDefKey,
                            // 			procDefId: procDefId
                            // 		}
                            // 	})
                            // }
                            //  })
                        },
                        onFail: (err) => {
                            this.$message.error('err:' + JSON.stringify(err));
                        }
                    });

                });
            },
            getQueryVariable(variable) {
                var query = window.location.href.split("?")[1]
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) {
                        return pair[1];
                    }
                }
                return (false);
            }
        }
    }
</script>

<style>
</style>
